module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"69f55bc2dd15f564b4fa7cd1a5a8da60"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
